import { createBasicSelector } from 'util/redux'
import { selectFuturePricingIds } from './selectFuturePricingIds'
import { selectAvailableFeaturesByPricingIds } from './selectAvailableFeaturesByPricingIds'

export const selectFutureAvailableFeatures = createBasicSelector(state => {
  const pricingIds = selectFuturePricingIds(state)
  return selectAvailableFeaturesByPricingIds(state, pricingIds)
})
